import { jsxs as E, jsx as p } from "react/jsx-runtime";
import { useState as i, useEffect as d } from "react";
import { Box as F, TextField as V, CircularProgress as q, Popover as Q } from "@mui/material";
import "../../../queries/message/index.js";
import { contact as m } from "../../../queries/contact/index.js";
import "../../../queries/calendars/index.js";
import "../../../index-DNTqwtVt.js";
import "../../../queries/student/index.js";
import "../../../queries/settings/index.js";
import "../../../queries/points/index.js";
import "../../../queries/assessment/index.js";
import "../../../queries/assessment/annotations/index.js";
import "../../../queries/assessment/rubrics/index.js";
import "../../../queries/assessment/qcesubjects/index.js";
import "../../../queries/assessment/extensionrequest/index.js";
import "../../../queries/files/index.js";
import "../../../queries/attendance/index.js";
import "../../../queries/forms/index.js";
import "../../../queries/notifications/index.js";
import "../../../queries/interviews/index.js";
import "../../../queries/notes/index.js";
import "../../../queries/annoucements/index.js";
import "../../../queries/payments/index.js";
import "../../../queries/assessment/analysis/index.js";
import "../../../queries/group/index.js";
import "../../../queries/projects/index.js";
import "../../../queries/courses/index.js";
import "../../../queries/password/index.js";
const gt = ({
  lookupType: u = "contacts",
  idMode: I = "contact",
  isRequired: g = !1,
  value: r,
  placeholder: P,
  title: T,
  onSelect: f
}) => {
  const [W, L] = i(r || null), [o, y] = i(""), [S, D] = i(null), [e, C] = i(r && r.Firstname ? r.Firstname + " " + r.Surname : ""), [k, x] = i([]), [l, c] = i(null);
  d(() => {
    C(r && r.Firstname ? r.Firstname + " " + r.Surname : "");
  }, [r]);
  const h = I !== "contact";
  let s;
  switch (u) {
    case "messagerecipients":
      s = new m.searchRecipients({ prefix: o });
      break;
    case "staff":
      s = new m.searchStaff({ prefix: o, daymapId: h });
      break;
    case "students":
      s = new m.searchStudents({ prefix: o, daymapId: h });
      break;
    case "parents":
      s = new m.searchParents({ prefix: o, daymapId: h });
      break;
    case "contacts":
    default:
      s = new m.searchContacts({ prefix: o, daymapId: h });
      break;
  }
  const { data: w, refetch: N, isFetching: z } = s.ToQuery(), A = async () => {
    if (e.length < 2 || e == null) {
      x([]), y("");
      return;
    }
    let t = e.split("; ").pop().toLowerCase(), n = t.length > 1 ? t.substr(0, 2) : t;
    n !== o && y(n);
  };
  d(() => {
    o && o.length >= 2 ? N() : (x([]), D(null));
  }, [o, N]), d(() => {
    if (w) {
      const t = w || [];
      for (let n = 0; n < t.length; n++) {
        let a = t[n];
        a.label = a.Firstname + " " + a.Surname + " (" + a.Name + ")", a.value = a.ID;
      }
      D(t), x(t);
    }
  }, [w]), d(() => {
    A();
  }, [e, u, I]);
  const B = (t) => {
    const n = t.target.value;
    C(n), c(t.currentTarget), n === "" && (L(null), f && f(null), c(null));
  }, j = (t) => {
    L(t), C(t.label), f && f(t), c(null);
  }, v = () => {
    c(null);
  }, O = e.length > 2 && S ? S.filter(
    (t) => t.Name.toLowerCase().startsWith(e.toLowerCase()) || t.Surname.toLowerCase().startsWith(e.toLowerCase()) || t.Firstname.toLowerCase().startsWith(e.toLowerCase())
  ) : k, b = () => g ? W != null : !0;
  return /* @__PURE__ */ E(F, { sx: { position: "relative", width: "100%" }, children: [
    /* @__PURE__ */ p(
      V,
      {
        id: "searchTxtInput",
        type: "text",
        fullWidth: !0,
        label: P || (u === "staff" ? "Staff Name" : u === "students" ? "Student Name" : "Contact Name"),
        title: T,
        value: e,
        onChange: B,
        onFocus: (t) => {
          e.length > 1 && c(t.currentTarget);
        },
        onBlur: b,
        autoComplete: "off",
        error: g && !b(),
        helperText: g && !b() ? "Contact required" : "",
        InputProps: {
          endAdornment: z ? /* @__PURE__ */ p(q, { size: 20, sx: { position: "absolute", right: 6, top: 3 } }) : null
        }
      }
    ),
    /* @__PURE__ */ p(
      Q,
      {
        open: !!l && O.length > 0 && e.length > 1,
        anchorEl: l,
        onClose: v,
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "center"
        },
        transformOrigin: {
          vertical: "top",
          horizontal: "center"
        },
        disableAutoFocus: !0,
        disableEnforceFocus: !0,
        slotProps: {
          paper: {
            sx: { width: (l == null ? void 0 : l.offsetWidth) || "auto", mt: 0.5 }
          }
        },
        children: /* @__PURE__ */ p(F, { children: O.map((t) => /* @__PURE__ */ p(
          F,
          {
            sx: { px: 2, py: 1, cursor: "pointer", "&:hover": { bgcolor: "grey.100" } },
            onMouseDown: () => j(t),
            children: t.label
          },
          t.value
        )) })
      }
    )
  ] });
};
export {
  gt as default
};
//# sourceMappingURL=index.js.map
